<template>
  <router-view></router-view> <!-- 現在表示されているコンポーネントがここに入る -->
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* スクロールバーを非表示にする */
body {
  overflow-x: hidden; /* 横スクロールバーを非表示 */
}

/* Webkit系ブラウザ（Chrome、Safari等）でスクロールバーを非表示 */
body::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}

/* Firefox でスクロールバーを非表示 */
body {
  scrollbar-width: none;
}

/* スクロールで画面内に入った要素をフェードインさせる (v-fade-in ディレクティブ用) */
.fade-in {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.fade-in.fade-in-visible {
  opacity: 1;
  transform: translateY(0);
}

@media (prefers-reduced-motion: reduce) {
  .fade-in {
    transition: none;
    opacity: 1;
    transform: none;
  }
}
</style>
